export default "__VITE_ASSET__CBBJz50o__"